<template>
  <div>
    <vs-tabs alignment="fixed">
      <vs-tab :label="'Functionnality'">
        <div>
          <h4 class="mb-4">Setting</h4>
          <vs-input
            :danger="errors.name"
            :danger-text="
              $t('Errors.InvalidPolite', {
                field: $t('Display.AddDisplayPrompt.Name'),
              })
            "
            :label="$t('Display.AddDisplayPrompt.Name')"
            v-model="promptData.name"
            class="w-100 mb-2"
          />
          <label>{{$t("Menu.Business")}}</label>
          <BusinessSelectFilterAll
              :multiselect="false"
              v-on:selectBusiness="loadQueuesByBusiness"
              :show-check-all="false"
          ></BusinessSelectFilterAll>
          <vs-select
            :danger="errors.queues"
            :danger-text="
              $t('Errors.InvalidPolite', {
                field: $t('Display.AddDisplayPrompt.Queues'),
              })
            "
            :placeholder="$t('Display.AddDisplayPrompt.Queues')"
            class="w-100 mb-2 mt-2"
            :label="$t('Display.AddDisplayPrompt.Queues')"
            autocomplete
            multiple
            :disabled="queueList.length === 0"
            v-model="promptData.queues"
          >
            <vs-select-item
              :key="index"
              :value="queue.id"
              :text="queue.title"
              v-for="(queue, index) in queueList"
            />
          </vs-select>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Kiosk.AddKioskPrompt.Status')"
            v-model="promptData.status"
          >
            <vs-select-item
              :value="0"
              :text="$t('Kiosk.AddKioskPrompt.StatusInactive')"
            />
            <vs-select-item
              :value="1"
              :text="$t('Kiosk.AddKioskPrompt.StatusActive')"
            />
          </vs-select>

          <vs-select
            class="w-100 mb-2 mt-2"
            :label="$t('Display.AddDisplayPrompt.Language')"
            v-model="promptData.locale"
          >
            <vs-select-item
              :key="index"
              :value="index"
              :text="item"
              v-for="(item, index) in locales"
            />
          </vs-select>

          <vs-input
            :label="$t('Display.AddDisplayPrompt.IpAddress')"
            v-model="promptData.ip_address"
            class="w-100 mb-2"
          />
          <vs-input
            :label="$t('Display.AddDisplayPrompt.MacAddress')"
            v-model="promptData.mac_address"
            class="w-100 mb-2"
          />

          <vs-row>
            <vs-col vs-lg="6">
              <vs-checkbox
                label="Collect customer details"
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.collectDetails"
              >
                {{ $t("Display.AddDisplayPrompt.CollectCustomerDetails") }}
              </vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6">
              <vs-checkbox
                label="Collect customer details"
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.playVoiceCall"
              >
                {{ $t("Display.AddDisplayPrompt.PlayVoiceCall") }}
              </vs-checkbox>
            </vs-col>
          </vs-row>

          <div v-if="promptData.playVoiceCall">
            <vs-input
              :label="$t('New.voiceNumber')"
              v-model="promptData.voiceNumber"
              class="w-100 mb-2"
            />
            <vs-input
              :label="$t('New.voiceCounter')"
              v-model="promptData.voiceCounter"
              class="w-100 mb-2"
            />
            <vs-input
              :label="$t('New.textNumber')"
              v-model="promptData.textNumber"
              class="w-100 mb-2"
            />
            <vs-input
              :label="$t('New.textCounter')"
              v-model="promptData.textCounter"
              class="w-100 mb-2"
            />
            <hr />
          </div>

          <vs-row>
            <vs-col vs-lg="6">
              <vs-checkbox
                label="Collect customer details"
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.show_approx_time"
              >
                Afficher l'approximation d'attente
              </vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6">
              <vs-checkbox
                label="Collect customer details"
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.show_time"
              >
                Afficher l'heure
              </vs-checkbox>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-lg="12">
              <vs-checkbox
                label="Collect customer details"
                class="justify-content-start w-100 mb-2 mt-2"
                v-model="promptData.call_language"
              >
                Synchroniser Language display avec ticket
              </vs-checkbox>
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>

      <vs-tab :label="'Appearance'">
        <vs-select
          class="w-100 mb-2 mt-2"
          :label="$t('Display.AddDisplayPrompt.Theme')"
          v-model="promptData.theme"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in themes"
          />
        </vs-select>
        <label class="vs-input--label" for="color-add-editPrimary">{{
          $t("Department.PrimaryColor")
        }}</label>
        <input
          id="color-add-editPrimary"
          v-model="promptData.color"
          type="color"
          class="w-100 mb-2"
        />

        <label class="vs-input--label" for="color-add-editSecondary">{{
          $t("Department.SecondaryColor")
        }}</label>
        <input
          id="color-add-editSecondary"
          v-model="promptData.colorSecondary"
          type="color"
          class="w-100 mb-2"
        />
        <label class="vs-input--label" for="color-add-editText">{{
          $t("Department.TextColor")
        }}</label>
        <input
          id="color-add-editText"
          v-model="promptData.colorText"
          type="color"
          class="w-100"
        />

        <vs-input
          type="file"
          class="w-100 mb-2 mt-2"
          id="fileInput"
          :label="$t('Display.AddDisplayPrompt.Photo')"
          v-model="promptData.photo"
        />

        <h4 class="mt-4 mb-4">
          New Style <small>{{ "(video url must be given)" }}</small>
        </h4>

        <vs-input
          :label="$t('Display.AddDisplayPrompt.VideoLink')"
          v-model="promptData.video_link"
          class="w-100 mb-2"
        />

        <div>
            <vs-row>
              <vs-input
                type="file"
                class="w-100 mt-2"
                id="updateImagesDisplay"
                label="slider image(s)"
                v-model="imageDisplay"
                @change="updateImagesDisplay"
              />

                <vs-col v-for="(item, key) in imagesDisplayArray">
                <p
                  class="text-primary mt-3"
                  @click="checkExistingImage(item)"
                  >display image N°{{ key+1 }}
                </p>
              </vs-col>

            </vs-row>
          </div>

          <vs-row>
            <vs-col vs-w="6">
              <vs-input
                label="interval in sliding images"
                v-model="promptData.pub_images_time_interval"
                class="w-100 mb-2"
                type="number"
                step="1000"
                min="1000" 
                max="300000"
              />
            </vs-col>
          </vs-row>
      </vs-tab>

      <vs-row class="ml-1 mt-3">
        <vs-col vs-w="4">
          <vs-button
            color="primary"
            @click="createDisplay()"
            class="w-100 mb-2"
            >{{ $t("Display.AddDisplayPrompt.SubmitButton") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-tabs>
  </div>
</template>

<script>
import {displayService, queueService} from "../../_services";
import { mapState } from "vuex";
import BusinessSelectFilterAll from "@/components/shared/BusinessSelectFilterAll.vue";

export default {
  name: "CreateDisplay",
  data: () => ({
    selectedBusiness:null,
    queueList:[],
    promptData: {
      show_approx_time: true,
      show_time: true,
      name: "",
      photo: "",
      theme: "liberrex",
      locale: "",
      collectDetails: 0,
      queues: [],
      status: 1,
      video_link: "",
      ip_address: "",
      mac_address: "",
      playVoiceCall: "",
      call_language: false,
      color: "",
      colorSecondary: "",
      colorText: "",
      voiceCounter: "",
      voiceNumber: "",
      textCounter: "",
      textNumber: "",
      pub_images_time_interval: null,
    },
    additionalData: null,
    showAdditionalData: false,
    departments: [],
    availableSlots: [],
    errors: {
      name: false,
      queues: false,
    },
    displayConfigV2: false,
    imageDisplay: null,
    imagesDisplayArray: []
  }),
  props: {
    queues: Array,
    locales: Object,
    themes: Array,
  },
  methods: {
    loadQueuesByBusiness(business) {
      this.queueList = [];
      this.selectedBusiness = business;
      queueService.getQueuesByBusinessId(business.id).then((data)=> {
        this.queueList = data.queues;
      })
    },
    checkExistingImage(base64) {
      var image = new Image();
      image.src = base64;

      var w = window.open("");
      w.document.write(image.outerHTML);
    },
    updateImagesDisplay() {
      if (
        document.getElementById("updateImagesDisplay") &&
        document.getElementById("updateImagesDisplay").files[0]
      ) {
        let rawImg;
        const file = document.getElementById("updateImagesDisplay").files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
          rawImg = reader.result;
          this.imagesDisplayArray.push(rawImg);
        };
        reader.readAsDataURL(file);
      }
    },
    validateFields() {
      this.errors.name = this.promptData.name ? false : true;
      this.errors.queues = this.promptData.queues.length > 0 ? false : true;

      let { name, queues } = this.errors;
      return !(name || queues);
    },
    sendKeySecret(key, secret, authToken) {
      this.$emit("credentials", {
        key: key,
        secret: secret,
        authToken: authToken,
      });
    },
    createDisplay() {
      let res = this.validateFields();
      if (!res) {
        this.activePrompt = true;
        return false;
      }
      this.showLoading();

      let kioskData = new FormData();
      kioskData.append("name", this.promptData.name);
      kioskData.append("queues", this.promptData.queues.join(","));
      kioskData.append("theme", this.promptData.theme);
      kioskData.append("color", this.promptData.color);
      kioskData.append("colorSecondary", this.promptData.colorSecondary);
      kioskData.append("colorText", this.promptData.colorText);
      kioskData.append("ip_address", this.promptData.ip_address);
      kioskData.append("video_link", this.promptData.video_link);
      kioskData.append("voice_call", this.promptData.playVoiceCall);
      kioskData.append("voiceNumber", this.promptData.voiceNumber);
      kioskData.append("voiceCounter", this.promptData.voiceCounter);
      kioskData.append("textNumber", this.promptData.textNumber);
      kioskData.append("textCounter", this.promptData.textCounter);
      kioskData.append("call_language", this.promptData.call_language);
      kioskData.append("mac_address", this.promptData.mac_address);
      kioskData.append("status", this.promptData.status);
      kioskData.append("business_id", this.selectedBusiness.id);
      kioskData.append(
        "collect_details",
        this.promptData.collectDetails ? 1 : 0
      );
      kioskData.append("locale", this.promptData.locale);
      if (
        document.getElementById("fileInput") &&
        document.getElementById("fileInput").files[0]
      ) {
        kioskData.append(
          "photo",
          document.getElementById("fileInput").files[0]
        );
      }
      kioskData.append("show_time", this.promptData.show_time);
      kioskData.append("show_approx_time", this.promptData.show_approx_time);
      if(this.imagesDisplayArray.length == 0) {
        kioskData.append("pub_images", null);
      } else {
        kioskData.append("pub_images",  this.imagesDisplayArray.join(",LBRX"));
      }
      if (this.promptData.pub_images_time_interval) {
        kioskData.append("pub_images_time_interval", this.promptData.pub_images_time_interval);
      } else {
        kioskData.append("pub_images_time_interval", null);
      }
      kioskData.append("show_approx_time", this.promptData.show_approx_time);
      kioskData.append("_method", "PUT");

      displayService
        .create(kioskData)
        .then(
          function(data) {
            this.getAllDisplays();
            this.sendKeySecret(data.key, data.secret, data.auto_auth_token);
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Display.AddDisplayPrompt.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Display.AddDisplayPrompt.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.close();
            this.hideLoading();
          }.bind(this)
        );
    },
    showLoading() {
      this.$vs.loading({
        container: "#kiosks-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#kiosks-box > .con-vs-loading");
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    getAllDisplays() {
      this.$emit("refresh_display", "refresh_display");
    },

    // refresh(value){
    //   this.selectedEvent = value;
    // },
    reset() {
      this.customer = "";
      this.activePrompt2 = false;
      this.activeEditPrompt = false;
      this.start = "";
      this.services = "";
      this.start_time = "";
      this.duration = 0;
      this.slotsLeft = 0;
      this.end = "";
      this.desc = "";
      this.requests = [];
      (this.importModal = {
        file: null,
        targetDepartment: null,
        notify: false,
      }),
        (this.selectedEvent = {
          id: "",
          customer: "",
          date: "",
          services: "",
          time: "",
          duration: 0,
          department_id: 0,
          slotsLeft: 0,
          no_slots: false,
          additionalData: {},
        });
    },
    close() {
      this.$emit("hide", "close");
    },
  },
  mounted() {
    this.promptData.locale = this.$i18n.locale;
  },
  components: {
    BusinessSelectFilterAll
  },
  computed: {
    ...mapState({
      business_info: (state) => state.account.user.business,
      working_days: (state) => state.account.user.working_days,
    }),
  },
};
</script>

<style scoped>
.booked-for {
  border: 1px solid #eee;
  padding: 10px;
  font-weight: bold;
}
.booked-for-image {
  width: 40px;
  border-radius: 50px;
  margin-right: 10px;
}
</style>
